<template>
  <vxe-modal v-model="visible" :loading="loading" :title="$t('button.batchAddContainer')" type="confirm" width="25%" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="{ span: 6 }" :model="args" :wrapper-col="{ span: 18 }">
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.containerType')" prop="'containerType.id'">
            <vxe-select v-model="args['containerType.id']" :options="containerTypes" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.beginNo')">
            <vxe-input v-model="args.begin" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.endNo')">
            <vxe-input v-model="args.end" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </vxe-modal>
</template>

<script>
import { post } from '@/api/Api'
import api from '@/api'

export default {
  name: 'ContainerEditor',
  props: {
    containerTypes: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      args: { 'containerType.id': undefined, physical: true, begin: '', end: '' },
      rules: {
        'containerType.id': [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      }
    }
  },
  methods: {
    open() {
      this.args = { 'containerType.id': undefined, physical: true, begin: '', end: '' }
      this.visible = true
    },
    save() {
      this.loading = true
      post(api.batchSave, { type: 'containerPersister' }, this.args).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.operationSuccess'))
          this.$emit('success')
          this.visible = false
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.save()
    }
  }
}
</script>